import * as React from 'react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import { confirmEmailWithTokenAsync } from '../../ajax/requests';
import { paths } from '../../app/constants';
import TurnstileWidget from '../../components/TurnstileWidget';

const ConfirmEmailAction: React.FC = () => {
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const token = params.get('token');

        if (!token) {
            window.location.href = paths.actionResult() + '#emailNotConfirmed';
            return;
        }

        confirmEmailWithTokenAsync(token)
            .then(() => {
                window.location.href = paths.actionResult() + '#emailConfirmed';
            })
            .catch(() => {
                window.location.href = paths.actionResult() + '#emailNotConfirmed';
            });
    }, [location.search]);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <TurnstileWidget />
            <Spinner color="primary" />
        </div>
    );
};

export default ConfirmEmailAction;
